import { Vue, Component } from "vue-property-decorator";
import Dashboard from "@/components/dashboard/Dashboard.vue";

@Component({
    name: "Home",
    components: {
        Dashboard,
    },

})
export default class Home extends Vue{}
